import React, { useState, useEffect } from 'react';
import { auth, saveApiCredentials, getApiCredentials } from '../firebase';
import { updateProfile, updateEmail, updatePassword, reauthenticateWithCredential, EmailAuthProvider } from 'firebase/auth';
import { Label, TextInput, Button, Alert } from 'flowbite-react';

const Account = () => {
  const [user, setUser] = useState(null);
  const [displayName, setDisplayName] = useState('');
  const [email, setEmail] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [currentPassword, setCurrentPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((currentUser) => {
      if (currentUser) {
        setUser(currentUser);
        setDisplayName(currentUser.displayName || '');
        setEmail(currentUser.email || '');
      }
    });
    return () => unsubscribe();
  }, []);

  const handleUpdateProfile = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    try {
      await updateProfile(auth.currentUser, { displayName });
      setMessage('Profile updated successfully');
    } catch (error) {
      setError('Error updating profile: ' + error.message);
    }
  };

  const handleUpdateEmail = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    try {
      await updateEmail(auth.currentUser, email);
      setMessage('Email updated successfully');
    } catch (error) {
      setError('Error updating email: ' + error.message);
    }
  };

  const handleUpdatePassword = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    try {
      const credential = EmailAuthProvider.credential(auth.currentUser.email, currentPassword);
      await reauthenticateWithCredential(auth.currentUser, credential);
      await updatePassword(auth.currentUser, newPassword);
      setMessage('Password updated successfully');
      setNewPassword('');
      setCurrentPassword('');
    } catch (error) {
      setError('Error updating password: ' + error.message);
    }
  };

  if (!user) {
    return <div>Loading...</div>;
  }

  return (
    <main className='h-full p-4 overflow-y-auto bg-slate-100 dark:bg-slate-900'>
      
      <div className="p-4 mb-4 rounded-lg dark:bg-slate-800 text-slate-400 bg-white">
      <div className="grid grid-cols-1">
      <h2 className="text-2xl font-bold mb-6 text-slate-900 dark:text-white">Account Settings</h2>
      
      <form onSubmit={handleUpdateProfile} className="mb-6">
        <div className="mb-2 block">
          <Label htmlFor="displayName" value="Display Name" />
        </div>
        <TextInput
          id="displayName"
          type="text"
          value={displayName}
          onChange={(e) => setDisplayName(e.target.value)}
          placeholder="Display Name"
        />
        <Button type="submit" className="mt-2">Update Profile</Button>
      </form>

      <form onSubmit={handleUpdateEmail} className="mb-6">
        <div className="mb-2 block">
          <Label htmlFor="email" value="Email" />
        </div>
        <TextInput
          id="email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="New Email"
        />
        <Button type="submit" className="mt-2">Update Email</Button>
      </form>

      <form onSubmit={handleUpdatePassword} className="mb-6">
        <div className="mb-2 block">
          <Label htmlFor="currentPassword" value="Current Password" />
        </div>
        <TextInput
          id="currentPassword"
          type="password"
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e.target.value)}
          placeholder="Current Password"
        />
        <div className="mb-2 block mt-2">
          <Label htmlFor="newPassword" value="New Password" />
        </div>
        <TextInput
          id="newPassword"
          type="password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          placeholder="New Password"
        />
        <Button type="submit" className="mt-2">Update Password</Button>
      </form>

      {message && <Alert color="success" className="mt-4">{message}</Alert>}
      {error && <Alert color="failure" className="mt-4">{error}</Alert>}

      </div>
      </div>
    </main>
  );
};

export default Account;